import { OptionsWithTZ, utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import { differenceInMinutes } from 'date-fns';

import { MINUTES_IN_HOUR } from '../../constants/date-time.constants';
import { TIMEZONE_ALIASES } from '../../constants/time-zones.constant';
import { timezonesCodeLabelMap } from '../timezones-code-label-map';
const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const zonedTimeToUtcOverride = (
    date: Date | string | number,
    anyTimezone: string,
    options?: OptionsWithTZ
): Date => {
    const canonicalTimezone = anyTimezone ? (TIMEZONE_ALIASES[anyTimezone] || anyTimezone) : localTimeZone;
    return zonedTimeToUtc(date, canonicalTimezone, options);
};

const utcToZonedTimeOverride = (
    date: Date | string | number,
    anyTimezone?: string,
    options?: OptionsWithTZ
): Date => {
    const canonicalTimezone = anyTimezone ? (TIMEZONE_ALIASES[anyTimezone] || anyTimezone) : localTimeZone;
    return utcToZonedTime(date, canonicalTimezone, options);
};

const getTimezoneOffsetInMinutes = (timezone: string, date?: Date) => {
    try {
        const dateToCalcOffsetFrom = date || new Date();
        const UTCTime = utcToZonedTime(dateToCalcOffsetFrom, 'UTC');
        const zonedTime = utcToZonedTime(dateToCalcOffsetFrom, timezone);
        return differenceInMinutes(zonedTime, UTCTime);
    } catch (error) {
        if (error instanceof RangeError) {
            return 0;
        } else {
            throw error;
        }
    }
};

const formatTimezoneOffset = (offsetInMinutes: number) => {
    let hours = offsetInMinutes / MINUTES_IN_HOUR;
    hours = hours > 0 ? Math.floor(hours) : Math.round(hours);
    const minutes = Math.abs(offsetInMinutes - hours * MINUTES_IN_HOUR);
    let hoursRepresentation = hours.toString(10);
    hoursRepresentation = hours < 0 ? hoursRepresentation : '+' + hoursRepresentation;
    let minutesRepresentation = minutes.toString(10);
    minutesRepresentation = minutesRepresentation.length === 2 ? minutesRepresentation : '0' + minutesRepresentation;
    return `${hoursRepresentation}:${minutesRepresentation}`;
};

const getTimezoneOffsetByDateInMinutes = (date: Date): number => {
    return date.getTimezoneOffset() * -1;
 };

const getFormattedTimezoneOffset = (date: Date): string => {
    const offsetInMinutes = getTimezoneOffsetByDateInMinutes(date);
    return 'GMT' + formatTimezoneOffset(offsetInMinutes);
};

const getFormattedTimezoneOffsetByTimezone = (timeZone: string): string => {
    const offsetInMinutes = getTimezoneOffsetInMinutes(timeZone);
    return 'GMT' + formatTimezoneOffset(offsetInMinutes);
};

const getFullFormattedTimezoneOffset = (timeZone: string): string => {
    return `${getFormattedTimezoneOffsetByTimezone(timeZone)} (${timezonesCodeLabelMap[timeZone] || timeZone})`;
};

const setToCurrentDay = (date: Date): Date => {
    date.setFullYear(new Date().getFullYear());
    date.setDate(new Date().getDate());
    date.setMonth(new Date().getMonth());
    return date;
};

export {
    zonedTimeToUtcOverride as zonedTimeToUtc,
    utcToZonedTimeOverride as utcToZonedTime,
    getTimezoneOffsetInMinutes,
    setToCurrentDay,
    formatTimezoneOffset,
    getFormattedTimezoneOffset,
    getFormattedTimezoneOffsetByTimezone,
    getFullFormattedTimezoneOffset
};
